<p
    #elm
    data-rating="★★★★★"
    class="stars text is-{{ starSize }} is-inline-block is-unselectable stars-{{ rating }}"
    [ngClass]="{ 'is-hidden': !rating, 'is-marginless': isMarginless }"
>
    ★★★★★
</p>
@if (rating && count) {
    <p class="text has-text-secondary is-inline-block">
        <span class="rating-numbers">{{ count }} avis</span>
    </p>
}
